export enum AuthState {
    Authenticated,
    Refreshing,
    Unauthenticated,
}